import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-ho-react';
import { AdditionalDiscountsPage, ConstructionPage } from 'ml-capability-quoteandbind-common-react';
import GWQuoteHOPolicyDetailsPage from './pages/PolicyDetails/PolicyDetailsPage';
import HOAdditionalInfoToQuotePage from './pages/HOAdditionalInfoToQuote/HOAdditionalInfoToQuote';
import HODisclosureToQuotePage from './pages/HODisclosureToQuote/HODisclosureToQuote';
import GatewayCompRaterHOValidateInformationPage from './pages/GatewayCompRaterHOValidateInformationPage/GatewayCompRaterHOValidateInformationPage';

setComponentMapOverrides(
    {
        GWQuoteHOPolicyDetailsPage: { component: 'GWQuoteHOPolicyDetailsPage' },
        HOAdditionalInfoToQuotePage: { component: 'HOAdditionalInfoToQuotePage' },
        HOAdditionalDiscountsPage: { component: 'HOAdditionalDiscountsPage' },
        HODisclosureToQuotePage: { component: 'HODisclosureToQuotePage' },
        GatewayCompRaterHOValidateInformationPage: { component: 'GatewayCompRaterHOValidateInformationPage' },
        HOConstructionPage: { component: 'HOConstructionPage'}
    },
    {
        GWQuoteHOPolicyDetailsPage,
        HOAdditionalDiscountsPage: AdditionalDiscountsPage,
        HOAdditionalInfoToQuotePage,
        HODisclosureToQuotePage,
        GatewayCompRaterHOValidateInformationPage,
        HOConstructionPage: ConstructionPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PEHOWizard } from './PEHOWizard';
